import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-article-summary',
  templateUrl: './article-summary.component.html',
  styleUrls: ['./article-summary.component.scss']
})
export class ArticleSummaryComponent implements OnInit {

  @Input() article;

  constructor() { }

  ngOnInit(): void {
  }
}
